export default __webpack_public_path__ + "static/media/P-008.ce3b048e.png";